export default "__VITE_ASSET__14431d22__"